import React from 'react';
import {Link} from 'react-router-dom';
import AurCheckbox from '../../../common/aur-checkbox/AurCheckbox';

const Checkbox: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Checkbox</h1>
        <div>
          Checkboxes allow the user to select one or more items from a set.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurCheckbox />
        </div>
      </div>
    </>
  );
};

export default Checkbox;
